import { render, staticRenderFns } from "./ContentListItemFullLabelWrapper.vue?vue&type=template&id=43a1fa87&scoped=true&"
import script from "./ContentListItemFullLabelWrapper.vue?vue&type=script&lang=js&"
export * from "./ContentListItemFullLabelWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ContentListItemFullLabelWrapper.vue?vue&type=style&index=0&id=43a1fa87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a1fa87",
  null
  
)

export default component.exports